import Arrow from 'Elements/Link/Arrow';
import styled, { css } from 'styled-components';

export const Container = styled.div`
    text-align: center;
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-weight: 300;
        font-family: ${theme.fonts.secondary};
    `}
`;

export const Description = styled.p`
    ${({ theme }) => css`
        width: 100%;
        place-self: center;

        @media ${theme.breakpoints.medium.media} {
            width: 80%;
        }
    `}
`;

export const List = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    gap: 1rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
`;

export const StyledArrowLink = styled(Arrow)`
    margin-top: 2rem;
`;

export const Disclaimer = styled.p`
    ${({ theme }) => css`
        font-size: 1.125rem;
        font-style: italic;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1rem;
        }
    `}
`;

export const Link = styled.a`
    transition: all 0.3s cubic-bezier(0, 0.21, 0.7, 0.95);
    display: block;

    &:hover {
        transform: scale(1.1);
        transform-origin: center;
    }
`;
